export default __webpack_public_path__ + "static/banner-media-release-oct4-3e28e0c689819f63b73885e4f7097c35.jpg";